import { useQuery } from '@tanstack/react-query';
import { clientService } from '@services/client';
import { useAppSelector } from '@redux/hooks';
import { RootState } from '@redux/store';
import { MyClientAccess } from '@models/client.model';
import { UserRoles } from '@models/user.model';

export const MY_CLIENT_ACCESS_QUERY_KEY = 'my-client-access';

/**
 * Sprint 43, story-223/224. A CLIENT user's own least-exposure checklist, read once and shared by
 * the client dashboard and the project detail page (same key, one network read). Only runs for
 * the CLIENT role. `data === null` (an unlinked CLIENT) means every key is OFF. No toast on
 * error: the page renders its own error message so it can fail closed with a retry.
 */
export const useMyClientAccess = () => {
  const organizationId = useAppSelector(
    (state: RootState) => state.organization.organizationId,
  );
  const role = useAppSelector((state: RootState) => state.user.role);

  return useQuery<MyClientAccess | null, Error>({
    queryKey: [MY_CLIENT_ACCESS_QUERY_KEY, organizationId],
    queryFn: () => clientService.getMyClientAccess(),
    enabled: !!organizationId && role === UserRoles.CLIENT,
    staleTime: 30_000,
    refetchOnWindowFocus: true,
    retry: 1,
  });
};

export default useMyClientAccess;
